<template>
    <div :class="['experience-link', { slim: layout.slim }]">
        <div class="cover underlayer">
            <div class="block">
                <span class="headline">
                    <Parallax class="caption" :effect="'translateX'" :power="-0.0625">
                        {{layout.data.headline}}
                    </Parallax>
                </span>
            </div>
        </div>
        <div
            class="cover"
        >
            <Parallax class="image-holder" :power="0.1">
                <div
                    class="image-holder scale"
                    :style="style"
                />
            </Parallax>
            <img
                :src="layout.data.image.url"
                :alt="layout.data.image.alt"
                :title="layout.data.image.title"
                class="seo-image"
            />
            <div
                :class="[{slick: !layout.slim}, 'block', 'main']"
            >
                <span class="headline" v-if="!layout.slim">
                    <Parallax class="caption" :effect="'translateX'" :power="-0.0625">
                        {{layout.data.headline}}
                    </Parallax>
                </span>
                <div class="content" v-if="layout.data">
                    <MaskTextFadeIn :type="'h2'" :onScroll="true" :content="layout.data.title" :lineHeight="-10"></MaskTextFadeIn>
                    <p class="baseline">{{layout.data.baseline}}</p>
                </div>
                <Cta
                    :type="'a'" :href="layout.data.url"
                    target="_blank"
                    class="link"
                    rel="noopener"
                >
                    {{layout.data.caption}}
                </Cta>
            </div>
        </div>
    </div>
</template>

<script>
import Cta from '@/components/Cta'
import MaskTextFadeIn from '@/components/animation/MaskTextFadeIn'
import Parallax from '@/components/animation/Parallax'
export default {
    components: {
        Cta,
        MaskTextFadeIn,
        Parallax
    },
    props: {
        layout: {
            type: Object,
            default() {}
        }
    },
    computed: {
        style()
        {
            return {backgroundImage: `url(${this.layout.data.image.url})`}
        }
    }
}
</script>

<style lang="sass" scoped>
@import "@/styles/vars.sass"
.experience-link
    position: relative
    height: 42.5vw
    margin-top: 10%
    margin-bottom: 10%
    @include media-breakpoint-up($xxl)
        height: 816px
    @include media-breakpoint-down($lg)
        height: auto
    @media print
        height: auto
        margin-bottom: 1.2cm
        margin-top: 1.2cm
    &.slim
        height: auto
.block
    display: flex
    flex-direction: column
    justify-content: center
    height: 100%
    &.main
        .slim &
            flex-direction: row
            justify-content: space-between
            padding-top: 3%
            padding-left: 7.625%
            padding-bottom: 3%
            padding-right: 7.625%
            @include media-breakpoint-down($lg)
                flex-direction: column
                padding-left: 0px
                padding-right: 0px
                margin-left: 72 / 750 * 100%
                margin-right: 72 / 750 * 100%

    .link
        align-self: end
        margin-bottom: -4%
        @media print
            margin-bottom: 0

            &:after
                content: "https://www.soletanche-bachy.com" attr(href)
                font-size: 12px
                font-weight: normal
                display: block
.slick
    margin-left: 18%

    @include media-breakpoint-down($lg)
        margin-left: 72 / 750 * 100%
        margin-right: 72 / 750 * 100%

.cover
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 100%
    z-index: 2
    overflow: hidden
    @include media-breakpoint-down($lg)
        padding-top: 10%
        padding-bottom: 10%
        position: static
    @media print
        padding-top: 0
        padding-bottom: 0
        position: static
    .slim &
        position: static
        width: auto
        height: auto
        top: initial
        left: initial
        margin-left: 10.41667%
        margin-right: 10.41667%
        @include media-breakpoint-down($lg)
            margin-left: 0
            margin-right: 0
    &.underlayer
        z-index: 0
        overflow: visible
        @include media-breakpoint-down($lg)
            display: none
.image-holder
    position: absolute
    left: 0
    top: 0
    width: 100%
    height: 100%
    background-position: 50% 50%
    background-repeat: no-repeat
    background-size: cover
    will-change: transform
    .slim &
        transform: none !important
        width: auto
        right: 0
        margin-left: 10.41667%
        margin-right: 10.41667%
        @include media-breakpoint-down($lg)
            margin-left: 0
            margin-right: 0


    .scale
        transform: scale(1.1)
        .slim &
            margin-left: 0
            margin-right: 0
.headline
    position: absolute
    left: 6.25%
    top: 5.9%
    transform: translateX(-50%) translateY(-50%) rotate(-90deg)
    @include media-breakpoint-down($lg)
        display: none
    .cover
        z-index: 2
    .caption
        color: #ffffff
        font-size: 50px
        font-weight: 500
        .underlayer &
            color: #114991

// img
//     width: 100%
//     height: auto
//     display: block
//     z-index: 1
//     position: relative

h2
    color: #ffffff
    font-weight: 500
    font-size: 8.3333333333vw
    line-height: .875
    @include media-breakpoint-up($xxl)
        font-size: 160px
    //     font-size: 120px
    // @include media-breakpoint-down($lg)
    //     font-size: 100px
    // @include media-breakpoint-down($sm)
    //     font-size: 50px
    .slim &
        font-size: 4.4791666667vw
        @include media-breakpoint-up($xxl)
            font-size: 86px
        @include media-breakpoint-down($lg)
            font-size: 70px
        @include media-breakpoint-down($sm)
            font-size: 50px
.baseline
    color: #ffffff
    font-weight: 500
    font-size: 28px
    margin-bottom: 4%
    margin-top: 4%
    line-height: 1.2
    position: relative
    @include media-breakpoint-down($hd)
        font-size: 18.8125px
    @include media-breakpoint-down($sm)
        font-size: 14px
    .slim &
        margin-bottom: 0%
        font-size: 20px
        @include media-breakpoint-down($lg)
            margin-bottom: 4%
</style>
